// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const FilterTitle: React.FC<{ size?: number; color1?: string; className?: string }> = ({ size = 16, className }) => (
    <svg className={className} focusable="false" viewBox="0 0 16 16" width={size} height={size}>
        <path
            fill="currentColor"
            d="M0 13c0 .275.225.5.5.5h2.05a2.501 2.501 0 0 0 4.9 0h8.05c.275 0 .5-.225.5-.5s-.225-.5-.5-.5H7.45a2.501 2.501 0 0 0-4.9 0H.5c-.275 0-.5.225-.5.5m3.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6-5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M11 5.5c-1.21 0-2.219.86-2.45 2H.5c-.275 0-.5.225-.5.5s.225.5.5.5h8.05a2.501 2.501 0 0 0 4.9 0h2.05c.275 0 .5-.225.5-.5s-.225-.5-.5-.5h-2.05c-.231-1.14-1.24-2-2.45-2m-5-1a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m2.45-2a2.501 2.501 0 0 0-4.9 0H.5c-.275 0-.5.225-.5.5s.225.5.5.5h3.05a2.501 2.501 0 0 0 4.9 0h7.05c.275 0 .5-.225.5-.5s-.225-.5-.5-.5z"
        />
    </svg>
);

export default React.memo(FilterTitle);
